<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-toolbar flat dense class="toolbar">
      <v-toolbar-title>Medical Details</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>
    </v-toolbar>
    <br />
    <v-row justify="center" align="center">
      <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
        <v-text-field
          rounded
          outlined
          color="#0F2027"
          flat
          dense
          v-model="inst_data.employee_code"
          name="employee_code"
          label="Employee Code"
          disabled
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row dense justify="center" align="center">
      <!-- <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
        <v-autocomplete
          dense
          rounded
          color="#0F2027"
          outlined
          :items="marital_status_list"
          item-text="name"
          item-value="id"
          v-model="inst_data.marital_status"
          label="Marital Status"
          placeholder="Select Marital Status " 
        >
          <template v-slot:prepend>
            <v-icon color="red" size="15px"> mdi-asterisk </v-icon>
          </template>
        </v-autocomplete>
      </v-col> -->
      <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
        <!-- <v-icon color="error">*</v-icon> -->
        <v-text-field
          rounded
          outlined
          color="#0F2027"
          flat
          dense
          v-model="inst_data.height"
          name="inst_height"
          label="Height in cm"
        >
          <template v-slot:prepend>
            <v-icon color="red" size="15px"> mdi-asterisk </v-icon>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
        <v-text-field
          rounded
          outlined
          color="#0F2027"
          flat
          dense
          v-model="inst_data.weight"
          name="inst_weight"
          label="Weight in KG"
        >
          <template v-slot:prepend>
            <v-icon color="red" size="15px"> mdi-asterisk </v-icon>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row dense justify="center" align="center">
      <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
        <v-text-field
          rounded
          outlined
          color="#0F2027"
          flat
          dense
          v-model="inst_data.family_doctor_name"
          name="inst_family_doctor_name"
          label="Family Doctor Name"
        >
          <template v-slot:prepend>
            <v-icon color="red" size="15px"> mdi-asterisk </v-icon>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
        <v-text-field
          rounded
          outlined
          color="#0F2027"
          flat
          dense
          v-model="inst_data.family_doctor_contact"
          name="inst_family_doctor_contact"
          label="Family Doctor Contact"
        >
          <template v-slot:prepend>
            <v-icon color="red" size="15px"> mdi-asterisk </v-icon>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row dense justify="center" align="center">
      <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
        <v-textarea
          rows="3"
          rounded
          outlined
          color="#0F2027"
          flat
          dense
          v-model="inst_data.family_disease_history"
          name="inst_family_disease_history"
          label="Family History Of Any Disease"
        >
          <template v-slot:prepend>
            <v-icon color="red" size="15px"> mdi-asterisk </v-icon>
          </template>
        </v-textarea>
      </v-col>
      <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
        <v-textarea
          rows="3"
          rounded
          outlined
          color="#0F2027"
          flat
          dense
          v-model="inst_data.allergeticto"
          name="inst_allergeticto"
          label="Allergetic To"
        >
          <template v-slot:prepend>
            <v-icon color="red" size="15px"> mdi-asterisk </v-icon>
          </template>
        </v-textarea>
      </v-col>
    </v-row>
    <v-row dense justify="center" align="center">
      <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
        <v-textarea
          rows="3"
          rounded
          outlined
          color="#0F2027"
          flat
          dense
          v-model="inst_data.past_medical_surgery_emergency"
          name="inst_past_medical_surgery_emergency"
          label="Any Past Medical Surgery/Medical Emergency"
        >
          <template v-slot:prepend>
            <v-icon color="red" size="15px"> mdi-asterisk </v-icon>
          </template>
        </v-textarea>
      </v-col>
      <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
        <v-autocomplete
          dense
          rounded
          color="#0F2027"
          outlined
          v-model="inst_data.is_medical_fitness_certificate_submitted"
          :items="inst_data.options"
          :name="inst_is_medical_fitness_certificate_submitted"
          hint="Is Medical Certificate Submitted..?"
          persistent-hint
          single-line
        >
          <template v-slot:prepend>
            <v-icon color="red" size="15px"> mdi-asterisk </v-icon>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>

    <v-row justify="center">
      <span v-if="inst_data.personHealthApproval">
        <strong
          >Medical Details Already Approved ..If U Want Changes Please Contact
          Doctor / Nurse...</strong
        >
      </span>
      <span v-else>
        <v-btn
          class="button"
          v-if="
            inst_data.height &&
            inst_data.weight &&
            inst_data.family_doctor_name &&
            inst_data.family_doctor_contact &&
            inst_data.family_disease_history &&
            inst_data.allergeticto &&
            inst_data.past_medical_surgery_emergency &&
            inst_data.is_medical_fitness_certificate_submitted
          "
          small
          @click="saveMedicalData()"
          >Save</v-btn
        >
      </span>
      <v-col cols="12" sm="3" md="4" align="right">
        <span>
          <v-icon @click="viewMedicalForm()" style> mdi-eye </v-icon>
          Medical/Health Form</span
        >
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Please wait..
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import moment from "moment";
export default {
  props: {
    instid: Number,
  },
  data() {
    return {
      snackbar_msg: "",
      color: "",
      snackbar: false,
      marital_status_list: [],
      inst_data: "",
      dialog_upload: false,
    };
  },
  watch: {
    instid() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    viewMedicalForm() {
      console.log("in view medical form fun");
      let routeData = this.$router.resolve({ name: "instructor-health-card" });
      window.open(routeData.href, "_blank");
    },

    getData() {
      this.instructor_id = this.instid;
      const formData = {
        instid: this.instid,
      };
      axios
        .post("/EmployeeProfile/getMedicalDetails", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            this.inst_data = res.data.inst_data;
            this.marital_status_list = res.data.marital_status_list;
          } else {
            // alert("Somthing went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Someting went wrong!!!");
          window.console.log(error);
          // alert("Somthing went wrong!!!");
        })
        .finally(() => {
          // this.comp_load = false;
        });
    },
    saveMedicalData() {
      this.dialog_upload = true;
      this.instructor_id = this.instid;
      const formData = {
        instid: this.instid,
        instrData: this.inst_data,
      };
      axios
        .post("/EmployeeProfile/saveEmployeeMedical", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            if (res.data.status == "SUCCESS") {
              this.showSnackbar(
                "#4caf50",
                "Medical details updated successfully..."
              );
            }
            this.dialog_upload = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Someting went wrong!!!");
          // alert("Somthing went wrong!!!");
        })
        .finally(() => {
          // this.comp_load = false;
        });
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>
